import * as React from 'react';
import { Helmet } from 'react-helmet';

import { getWhitelabelFavicon, getWhitelabelPageTitle } from '../../common/utils/whitelabelHelper';

export interface WhitelabelHelmetProps {
    children?: React.ReactNode;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
const publicUrl = window.__webpack_public_path__;

const WhitelabelHelmet: React.FunctionComponent<WhitelabelHelmetProps> = () => {
    return (
        <Helmet>
            <title>{getWhitelabelPageTitle()}</title>
            <link rel="shortcut icon" type="image/x-icon" href={publicUrl + (publicUrl ? '' : '/app/') + getWhitelabelFavicon()} />
        </Helmet>
    );
};

export default WhitelabelHelmet;
